import { render } from "./module6.vue?vue&type=template&id=57036304&scoped=true&ts=true"
import script from "./module6.vue?vue&type=script&lang=ts"
export * from "./module6.vue?vue&type=script&lang=ts"

import "./module6.vue?vue&type=style&index=0&id=57036304&lang=less&scoped=true"

import exportComponent from "/Users/julianzeng/Desktop/Buz/mainland/fuwangleyou-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57036304"]])

export default __exports__